import { Auth } from 'aws-amplify';

const Dashboard = () => {
  return (
    <div>
      <h1>Dashboard</h1>
      <button
        onClick={async () => {
          await Auth.signOut({ global: true });
          localStorage.clear();
          window.location.pathname = '/login';
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default Dashboard;
